const ACCESS_KEY = 'juniverso_access'
const REFRESH_KEY = 'juniverso_refresh'

type RuntimeStore = {
  getItem: (key: string) => Promise<string | null>
  setItem: (key: string, value: string) => Promise<void>
  removeItem: (key: string) => Promise<void>
}

function runtimeStore(): RuntimeStore | null {
  const storage = (
    globalThis as {
      OfficeRuntime?: { storage?: RuntimeStore }
    }
  ).OfficeRuntime?.storage
  return storage ?? null
}

export function authHeaders(token: string): Record<string, string> {
  if (token.startsWith('eyJ')) {
    return { Authorization: `Bearer ${token}` }
  }
  return { 'X-Tenant-Token': token }
}

export function getAccessToken(): string | null {
  return localStorage.getItem(ACCESS_KEY)
}

export function getRefreshToken(): string | null {
  return localStorage.getItem(REFRESH_KEY)
}

export async function persistSession(access: string, refresh: string): Promise<void> {
  localStorage.setItem(ACCESS_KEY, access)
  localStorage.setItem(REFRESH_KEY, refresh)
  const rt = runtimeStore()
  if (rt) {
    await rt.setItem(REFRESH_KEY, refresh)
    await rt.setItem(ACCESS_KEY, access)
  }
}

export async function loadPersistedRefresh(): Promise<string | null> {
  const rt = runtimeStore()
  if (rt) {
    const fromOffice = await rt.getItem(REFRESH_KEY)
    if (fromOffice) {
      localStorage.setItem(REFRESH_KEY, fromOffice)
      return fromOffice
    }
  }
  return localStorage.getItem(REFRESH_KEY)
}

export async function clearSession(): Promise<void> {
  localStorage.removeItem(ACCESS_KEY)
  localStorage.removeItem(REFRESH_KEY)
  const rt = runtimeStore()
  if (rt) {
    await rt.removeItem(ACCESS_KEY)
    await rt.removeItem(REFRESH_KEY)
  }
}
